import { render, staticRenderFns } from "./OtherSpecifications.vue?vue&type=template&id=b94305b4&scoped=true"
import script from "./OtherSpecifications.vue?vue&type=script&lang=ts"
export * from "./OtherSpecifications.vue?vue&type=script&lang=ts"
import style0 from "./OtherSpecifications.vue?vue&type=style&index=0&id=b94305b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94305b4",
  null
  
)

export default component.exports